import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { OnboardingProgressResponse } from "../interfaces/lead_onboarding/onboarding-progress.interface";
import { HttpClientService } from "./http-client.service";

@Injectable()
export class OnboardingProgressService {
  constructor(private http: HttpClientService) {}

  public getOnboardingProgress(applicationIds: readonly (string | number)[]): Observable<OnboardingProgressResponse> {
    let params = new HttpParams();
    for (const id of applicationIds) {
      params = params.append("application_ids[]", String(id));
    }
    return this.http
      .get<OnboardingProgressResponse>("/api/onboarding_progress", { params })
      .pipe(tap((_) => console.log("OnboardingProgressService.getOnboardingProgress: Ok.")));
  }
}
